import { Component, Input, AfterViewInit, ViewChildren, QueryList, ElementRef, Renderer2, OnInit } from '@angular/core';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BaseShiftIconsEnum, TimeAndShiftsFormInterface, ShiftType, BaseInquiryShifts, FormRawValue } from 'base';

@Component({
  selector: 'base-customer-edit-shift-view-modal',
  templateUrl: './base-customer-edit-shift-times-modal.component.html',
})
export class BaseCustomerEditShiftTimesModalComponent implements AfterViewInit, OnInit {
  @ViewChildren('startTimeInput') startTimeInputs: QueryList<ElementRef>;

  @Input({ required: true }) parentForm: FormGroup<{
    timeShiftsForm: FormArray<FormGroup<TimeAndShiftsFormInterface>>;
  }>;
  @Input({ required: true }) modalRef: NgbModalRef;
  @Input() activeShiftType: ShiftType;

  form = new FormGroup({
    timeShiftsForm: new FormArray<FormGroup<TimeAndShiftsFormInterface>>([]),
  });
  baseShiftIconsEnum = BaseShiftIconsEnum;
  validated = false;

  constructor(private renderer: Renderer2) {}

  get timeShiftsForm(): FormArray<FormGroup<TimeAndShiftsFormInterface>> {
    return this.form.controls.timeShiftsForm as FormArray<FormGroup<TimeAndShiftsFormInterface>>;
  }

  ngOnInit() {
    this.updateForm();
  }

  ngAfterViewInit(): void {
    this.setAutofocus();
  }

  setAutofocus(): void {
    this.timeShiftsForm.controls.forEach((shift, index) => {
      const inputElement = this.startTimeInputs.toArray()[index];

      if (shift.value.type === this.activeShiftType) {
        this.renderer.selectRootElement(inputElement.nativeElement).focus();
      }
    });
  }

  closeModal() {
    this.modalRef.dismiss();
  }

  saveTimeShifts() {
    this.validated = true;

    if (this.timeShiftsForm.valid) {
      this.modalRef.close(this.timeShiftsForm.getRawValue());
      this.parentForm.controls.timeShiftsForm.setValue(this.timeShiftsForm.getRawValue());
    }
  }

  private updateForm() {
    this.timeShiftsForm.clear();

    this.parentForm.controls.timeShiftsForm
      .getRawValue()
      .forEach((shift: FormRawValue<FormGroup<TimeAndShiftsFormInterface>>) => {
        this.timeShiftsForm.push(
          new FormGroup<TimeAndShiftsFormInterface>({
            type: new FormControl<BaseInquiryShifts>(shift.type, { nonNullable: true }),
            startTime: new FormControl<string>(shift.startTime, {
              nonNullable: true,
              validators: Validators.required,
            }),
            endTime: new FormControl<string>(shift.endTime, {
              nonNullable: true,
              validators: Validators.required,
            }),
            break: new FormControl<number>(shift.break, { nonNullable: true }),
          })
        );
      });
  }
}
